import { JetView } from "webix-jet";
import { getInfoList } from "../../helpers/infolist";

export default class DetailsView extends JetView {
	config() {
		this.WithRoles = this.app.config.roles;
		this.Compact = this.getParam("compact", true);
		const padding = { left: 10 };

		const headers = {
			view: "toolbar",
			padding,
			cols: [
				{
					view: "icon",
					icon: "umi-back",
					click: () =>
						this.app.callEvent("details.back:click", [
							"rules",
							this.getParam("id", true),
						]),
					hidden: !this.Compact,
				},
				{ view: "label", label: "Rule information" },
				{},
			],
		};

		const details = {
			view: "template",
			localId: "title",
			autoheight: true,
			template: this.TitleTemplate,
		};

		const info = {
			view: "template",
			localId: "info",
			scroll: true,
			onClick: {
				webix_um_infolist_users_name: e => {
					let id = webix.html.locate(e, "data-id");
					this.app.callEvent("details:item-click", ["users", id]);
				},
				webix_um_infolist_roles_name: e => {
					let id = webix.html.locate(e, "data-id");
					this.app.callEvent("details:item-click", ["roles", id]);
				},
			},
		};

		return {
			maxWidth: this.Compact ? 10000 : 350,
			rows: [
				headers,
				{
					type: "clean",
					rows: [details, info],
				},
			],
		};
	}

	urlChange() {
		this.ID = this.getParam("id", true) * 1;
		const local = this.app.getService("local");
		let colls = [local.users()];
		if (this.WithRoles) colls.push(local.roles());
		const rules = local.rules(true);
		rules.waitData.then(() => {
			if (!this.getRoot()) return;

			const rule = rules.getItem(this.ID);
			this.SetTitle(rule);
			Promise.all(colls).then(data => {
				this.SetDetails(rule, data[0], data[1] || null);
			});
		});
	}

	SetTitle(rule) {
		this.$$("title").setValues(rule);
	}

	SetDetails(rule, allUsers, allRoles) {
		this.$$("info").setHTML(this.GetDetailsHTML(rule, allUsers, allRoles));
	}

	GetDetailsHTML(rule, allUsers, allRoles) {
		return this.GetListsHTML(rule, allUsers, allRoles);
	}

	TitleTemplate(rule) {
		return (
			`<div class='webix_um_title'>${rule.short || ""}</div>` +
			`<div class='webix_um_description'>${rule.long || ""}</div>`
		);
	}
	GetRoles(id, data) {
		let roles = [];
		if (data)
			data.data.each(function(role) {
				if (role.rules && role.rules.indexOf(id) >= 0) roles.push(role);
			});
		return roles;
	}

	GetUsers(id, uData, rData) {
		let users = [];
		uData.data.each(user => {
			if (user.rules && user.rules.indexOf(id) >= 0) users.push(user);
			else if (rData && this.WithRoles && user.roles) {
				for (let i = 0; i < user.roles.length; i++) {
					let role = rData.getItem(user.roles[i]);
					if (role.rules && role.rules.indexOf(id) >= 0) {
						users.push(user);
						break;
					}
				}
			}
		});

		return users;
	}

	GetAssignments(rule, allUsers, allRoles) {
		let assigned = {};
		assigned.roles = this.GetRoles(rule.id, allRoles);
		assigned.users = this.GetUsers(rule.id, allUsers, allRoles);
		return assigned;
	}

	GetListsHTML(rule, uData, rData) {
		const _ = this.app.getService("locale")._;
		let configs = [];
		let assigned = this.GetAssignments(rule, uData, rData);
		if (this.WithRoles)
			configs.push({
				name: "roles",
				data: assigned.roles,
				key: "name",
				title: _("Roles"),
				icon: "umi-roles",
			});

		return getInfoList(
			configs.concat({
				name: "users",
				data: assigned.users,
				key: "name",
				title: _("Users"),
				icon: "umi-users",
			})
		);
	}
}
